import { addSearchQueryToUrl } from '~/src/common/navigation';
import { PLAYLIST_QUERY_STRING_KEY } from '~/src/common/playlist';

import { CONVERTED_CONTENT_FROM_STORAGE_KEY } from './constants';

export const addToUrlConvertedContentFrom =
  (currentLocation: Location) =>
  ({ returnUrl, targetUrl }: { targetUrl: string; returnUrl?: string }): string => {
    const url = returnUrl ?? `${currentLocation.pathname}`;

    const searchParams = new URLSearchParams(currentLocation?.search);
    searchParams.set(CONVERTED_CONTENT_FROM_STORAGE_KEY, url);
    searchParams.delete(PLAYLIST_QUERY_STRING_KEY);

    return addSearchQueryToUrl(targetUrl, searchParams.toString());
  };
